export * as NotesApi from './api';
export var NoteRelation;
(function (NoteRelation) {
    NoteRelation["Adviser"] = "adviser";
    NoteRelation["Investor"] = "investor";
    NoteRelation["Investment"] = "investment";
})(NoteRelation || (NoteRelation = {}));
//# sourceMappingURL=index.js.map